"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var zIndex = {
  base: 100,
  menu: 200,
  nav: 300,
  modal: 400,
  toast: 500,
  dragging: 600,
  topBarLoader: 100001 // https://github.com/buunguyen/topbar/blob/master/topbar.js#L75
};
var _default = exports.default = zIndex;
//# sourceMappingURL=zIndex.js.map